import { render } from "./DailyDataForm.vue?vue&type=template&id=65c961c4"
import script from "./DailyDataForm.vue?vue&type=script&lang=js"
export * from "./DailyDataForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__